var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"building-model-scroll-div",attrs:{"id":"building-model-scroll-div"}},[_c('div',{staticClass:"project-structure-building-model",style:(`left: calc(${_vm.model_offset.x}px + 50%); top: calc(${_vm.model_offset.y}px + 50%)`),attrs:{"id":"project-structure-building-model"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }